import BaseModel from "../BaseModel";
import ContractType from "./ContractType";

export default class Contract extends BaseModel{
    static entity = 'contracts';
    static fields(){
        return {
            id: this.attr(null),
            customer_id: this.attr(null),
            contract_type_id: this.attr(null),
            user_id: this.attr(null),
            contract_type: this.belongsTo(ContractType, 'contract_type_id')
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at', 'contract_type']
    }
    static route(){
        return '/contracts'
    }
}
